var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCinedOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#b4b4b4;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17_",
    className: "st0",
    cx: 200,
    cy: 200,
    r: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st1",
    d: "M160.7,291.7l59.5-34.4l59.5-34.4c17.6-10.2,17.6-35.6,0-45.8L262,166.9L136.2,292.7 C143.6,296.2,152.6,296.3,160.7,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st1",
    d: "M160.7,108.3c-17.6-10.2-39.7,2.5-39.7,22.9V200v39.2l97.5-97.5L160.7,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st1",
    d: "M121,268.7v-19.7l-44.3,44.3l24.5,24.5l29-29C124.7,284.1,121,277,121,268.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    className: "st1",
    points: "294.8,124.2 270.4,99.7 224.7,145.3 255.8,163.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st1",
    d: "M121,268.7c0,8.3,3.7,15.3,9.2,20.1l125.6-125.6l-31-17.9L121,249.1V268.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCinedOff);
export default __webpack_public_path__ + "static/media/play_cined_off.8e30ca9b196b92118722d71b023d6ca3.svg";
export { ForwardRef as ReactComponent };